import { useMutation as e } from "@tanstack/react-query";
import { requestOTPMutation as o } from "../reactQuery.es.js";
const s = (t) => e(o(t));
export {
  s as useRequestOTP
};
